import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端签收列表
export const getSignList = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/GetTFSignForList`, { ...params }).then(res => res.data)
}

// 获取移动端签收送货明细
export const getDeliveryNo = params => {
    return axios.get(`${BaseApiUrl}/TFMobile/GetSignForByDeliveryNo`, { params }).then(res => res.data);
}

// 移动端确认签收
export const submitSignFor = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/InsertTFSignFor`, { ...params }).then(res => res.data);
}

// 移动端确认签收收货
export const submitSignForAndReceive = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/InsertTFSignForAndReceive`, { ...params }).then(res => res.data);
}

// 获取移动端签收预报明细
export const getDeliveryPreBox = params => {
    return axios.get(`${BaseApiUrl}/TFMobile/GetPreBoxByDeliveryNo`, { params }).then(res => res.data);
}
//获取设备测量数据
export const getDeliveryMachineBox = params => {
    return axios.get(`${BaseApiUrl}/TFMobile/GetMachineBoxByDeliveryNo`, { params }).then(res => res.data);
}